import React from 'react';
import { MenuItem } from '../../components/Menu';
import OverflowMenu from '../../components/OverflowMenu';
import { useQuill } from '../../editor/QuillContext';
import trashIcon from '../../icons/non-prefilled/16x16/trash.svg';
import MagneticWallSheet from '../MagneticWallSheet';
import styles from './ReactionThreadSheet.module.scss';
import { useAddReaction, useDeleteReaction } from './reactionsMutations';
import ThreadReactionList from './ThreadReactionList';
import { CommentThreadSheetContext } from './CommentThreadSheet';
import useDeleteReactionThread from './useDeleteReactionThread';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const THREAD_FRAGMENT = gql(`
  fragment ReactionThreadSheet_thread on PublicThreadFields {
    id
    comments {
      id
    }
    reactions {
      id
      ...ThreadReactionList_reactions
    }
  }
`);

interface ReactionThreadSheetProps {
  thread: DocumentType<typeof THREAD_FRAGMENT>;
  onClose: () => void;
}

const ReactionThreadSheet = ({ onClose, thread }: ReactionThreadSheetProps) => {
  const { quill } = useQuill();

  const addReaction = useAddReaction();
  const deleteReaction = useDeleteReaction();

  const deleteReactionThread = useDeleteReactionThread();

  const handleDeleteAllReactions = () => {
    deleteReactionThread(thread.id);
  };

  return (
    <MagneticWallSheet
      onClose={onClose}
      title="Reaction"
      headerContent={
        <CommentThreadSheetContext id={thread.id} type="comment" highlight />
      }
      overflowMenu={
        <OverflowMenu>
          <MenuItem danger icon={trashIcon} onClick={handleDeleteAllReactions}>
            Delete all
          </MenuItem>
        </OverflowMenu>
      }
    >
      {thread.reactions.length > 0 && (
        <div className={styles.reactions}>
          <ThreadReactionList
            reactions={thread.reactions}
            onAdd={(emoji) => addReaction(emoji, thread.id)}
            onRemove={(id) => deleteReaction(id, thread, quill)}
            expanded
          />
        </div>
      )}
    </MagneticWallSheet>
  );
};

export default ReactionThreadSheet;
